import { FC, PropsWithChildren } from "react";

import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useDocument } from "react-firebase-hooks/firestore";

import { PageLoader } from "@components/PageLoader/PageLoader";

import { getUserDocRef } from "../../services/user.services";

import { IUser } from "@models/user.model";
import { AuthContext } from "./contexts/Auth.context";

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [authUser, isAuthUserLoading] = useAuthState(getAuth());
  const [doc, isUserLoading] = useDocument(
    authUser ? getUserDocRef(authUser.uid) : undefined
  );

  const isLoading = isAuthUserLoading || isUserLoading;

  const user = doc?.data() as IUser | undefined;

  if (isLoading || (authUser && !user)) return <PageLoader />;

  return (
    <AuthContext.Provider value={authUser && user ? { authUser, user } : null}>
      {children}
    </AuthContext.Provider>
  );
};
